import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { GroupList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { GroupCreateInitializer } from "./create/initializer";
import { GroupDetailInitializer } from "./detailInitializer";

const GroupRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<GroupList />} />
        <Route path={`-create/*`} element={<GroupCreateInitializer />} />
        <Route path={`:group/*`} element={<GroupDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default GroupRoute;
